<prism-dialog
	id="sh-feature-request-dialog-container"
	[visible]="true"
	confirm-button=""
	cancel-button=""
	*transloco="let t; read: 'cloud.shared.feature-request'"
>
	<span id="sh-feature-request-dialog-title-h1" slot="dialog-title">
		{{ t('feature-request') }}
	</span>
	<div id="sh-feature-request-dialog-description-div">
		{{ t('feature-popup-info') }}
	</div>
	<form [formGroup]="formGroup">
		<prism-input
			id="sh-feature-request-dialog-idea-summary-input"
			formControlName="title"
			type="text"
			autofocus="true"
			inputmode="text"
		>
			<span slot="label">{{ t('idea-summary') }}</span>
		</prism-input>

		<prism-textarea
			id="sh-feature-request-dialog-description-form-field"
			[placeholder]="t('more-details')"
			formControlName="description"
			minlength="0"
			maxlength="300"
			autofocus="false"
			rows="6"
			[isValid]="formGroup.controls['description'].valid"
			required="true"
		>
			<span slot="label" id="sh-feature-request-dialog-description-label">{{ t('more-details') }}</span>

			@if (
				formGroup.controls['description'].errors &&
				formGroup.controls['description'].touched &&
				formGroup.controls['description'].hasError('required')
			) {
				<span
					*transloco="let t; read: 'cloud.shared.error-labels'"
					slot="error-text"
					id="sh-feature-request-dialog-error-text-span"
					class="prism-caption sh-feature-request-dialog-error-text"
					>{{ t('required-field') }}</span
				>
			}
		</prism-textarea>
	</form>
	<div id="sh-feature-request-dialog-contact-info-div" class="prism-caption">
		{{ t('feature-request-contact-info') }}
	</div>
	<div
		class="sh-feature-request-dialog-buttons"
		id="sh-feature-request-dialog-action-buttons-div"
		*transloco="let t; read: 'cloud.shared.button-text'"
	>
		<span slot="end">
			<prism-button variant="text" size="md" (click)="closeDialog()">
				{{ t('cancel') }}
			</prism-button>

			<prism-button variant="text" [disabled]="formGroup.invalid || !isFormChanged" (click)="doAction()">
				{{ t('send') }}
			</prism-button>
		</span>
	</div>
</prism-dialog>
